/**
 * Search Api Service for FunnelBack. Responsible communicating with the FunnelBack back end.
 */
import _ from 'lodash';
import jQuery from 'jquery';

/**
 * Search FunnelBack API Service constructor
 *
 * @constructor
 */
function SearchFunnelBackApiService() {
}

/**
 * Sending a search request to the FunnelBack
 *
 * @param {String} url  Search URL
 * @param {String} value  Search key
 * @param {Number} limit  Page limit
 * @param {Number} offset  Page offset
 * @param {String} culture  Search key
 * @returns {Promise}
 *
 * @public
 */
SearchFunnelBackApiService.prototype.search = function (url, value, limit, offset, culture) {
    var deferred = jQuery.Deferred();

    this.abortRequest();

    this.request = jQuery.ajax({
        method: 'GET',
        timeout: 30000,
        url: url,
        data: {
            query: encodeURIComponent(value),
            num_ranks: limit,
            start_rank: offset,
            culture: culture,
        },
    });

    this.request
        .done(function (data) {
            if (this.isValidData(data)) {
                deferred.resolve(data);
            } else {
                deferred.reject('Invalid response');
            }
        }.bind(this))
        .fail(function (err) {
            deferred.reject(err);
        });

    return deferred.promise();
};

/**
 * Search result validator
 *
 * @param {Object} data  Search result
 *
 * @returns {Boolean}
 *
 * @private
 */
SearchFunnelBackApiService.prototype.isValidData = function (data) {
    return _.isObject(data) &&
        data.hasOwnProperty('results') &&
        data.hasOwnProperty('sportResults') &&
        data.hasOwnProperty('pagination');

};

/**
 * Aborting the search request
 *
 * @returns {void}
 *
 * @public
 */
SearchFunnelBackApiService.prototype.abortRequest = function () {
    if (this.hasOwnProperty('request') && this.request.readyState !== 4) {
        this.request.abort();
    }

    delete this.request;
};

export default new SearchFunnelBackApiService();
